import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/shared/ui-kit/g/ui/select';
import { useLocale } from '@/shared/i18n/locale-context';
import { Locale } from '@/shared/i18n/messages';

const LANGUAGES: { value: Locale; flag: string; label: string }[] = [
	{ value: 'en', flag: '🇬🇧', label: 'English' },
	{ value: 'no', flag: '🇳🇴', label: 'Norsk' },
];

export function LocaleSwitcher() {
	const { locale, setLocale } = useLocale();

	return (
		<Select value={locale} onValueChange={(v) => setLocale(v as Locale)}>
			<SelectTrigger className="w-36 h-8 text-sm">
				<SelectValue />
			</SelectTrigger>
			<SelectContent>
				{LANGUAGES.map((lang) => (
					<SelectItem key={lang.value} value={lang.value}>
						<span className="flex items-center gap-2">
							<span>{lang.flag}</span>
							<span>{lang.label}</span>
						</span>
					</SelectItem>
				))}
			</SelectContent>
		</Select>
	);
}
